<template>
  <div class="pupils">
    <div v-if="isInModal" class="top-bar text-left">
       <i class="fas fa-times close-icon pl-4 hover:opacity-75" title="Close"  @click="$emit('close')"></i>
      <button
            @click="$emit('close')"
            type="button"
            class="publish-button hover:bg-blue-300 float-right"
          >
            Done
          </button>
    </div>

    <header class="w-95p mx-auto my-6">

      <slot name="title"> 

       <p class="ml-1 pt-2 text-gray-500">
        {{ filteredList.length }} pupils in view
      </p>

      </slot>
    </header>

   <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div style="width: 100%; text-align: center" v-if="loading">
        <i class="spinner fa fa-spinner fa-spin"></i>
      </div>

      <section v-else>
        <div v-if="componentLoaded" class="grid grid-cols-4 gap-4 w-95p mx-auto">
          <div
            v-for="pupil in filteredList"
            :key="pupil.identifier"
            @click="selectPupil(pupil)"
            class="
              group
              w-full
              bg-white
              mx-auto
              rounded
              shadow-sm
              p-3
              cursor-pointer
              hover:opacity-50
            "
          >
            <template v-if="allowMultiple">
              <span v-if="inSelected(pupil)">
                <i class="fas fa-check-circle text-green-300   text-2xl                  float-right
                  group-hover:text-green-900 group-hover:opacity-100"></i
              ></span>
              <span v-else >
                <i class="fas fa-circle text-gray-300   text-2xl                float-right
                  group-hover:text-green-900 group-hover:opacity-100"></i>
              </span>
            </template>
            <template v-else>
              <i
                class="
                  fas
                  fa-ellipsis-h
                  float-right
                  group-hover:text-red-900 group-hover:opacity-100
                "
              ></i>
            </template>

            <div class="flex items-center">
              <!-- <img
                class="w-12 h-12 rounded-full mr-4"
                src="https://pbs.twimg.com/profile_images/885868801232961537/b1F6H4KC_400x400.jpg"
                alt="Avatar of Jonathan Reinink"
              /> -->
              <div
                class="
                  w-14
                  h-14
                  rounded-full
                  mr-4
                  bg-gray-300
                  text-lg text-center
                  pt-3
                "
              >
                {{ getPupilInitials(pupil) }}
              </div>
              <div class="text-sm">
                <p class="text-black leading-none">{{ pupil.name }}</p>
                <p class="text-gray-500 text-xs pt-1">{{ pupil.class }}</p>
              </div>
            </div>
          </div>
        </div>
        <p class="m-5 mx-12" v-else>
          We could not find any data for your given selection.
        </p>
      </section>
    </div>
      </div>
</template>

<script>
import { mapGetters } from "vuex";

const innertopbar = () => import("@/components/InnerTopBar.vue");

export default {
  name: "pupils",
  props: {
    orderedPupils: { type: Array, required: true },
    selectedPupils: { type: Array, required: false },
    allowMultiple: { type: Boolean, required: false },
    isInModal: { type: Boolean, required: false },
    inputSearch: { type: String, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.filteredList.length > 0;
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    filteredList() {
      return this.orderedPupils.filter((item) => {
        var vm = this;
        return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });
    },
  },
  data() {
    return {
      search: this.inputSearch != undefined ? this.inputSearch : "",
      loading: false,
      errored: false,
    };
  },
  watch: {
    inputSearch: function (val) {
      this.search = val
    },
  },
  created() {},
  mounted() {},
  methods: {
    getPupilInitials(pupil) {
      return pupil.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3);
    },
    inSelected(pupil) {
      let found = this.selectedPupils.find(
        (l) => l.identifier === pupil.identifier
      );
      return found;
    },
    selectPupil(pupil) {
      this.$emit("pupil-selected", pupil);
    },
  },
  components: {
    innertopbar
  },
};
</script>
